import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const EnergyCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [dailyHours, setDailyHours] = useState('8');
  const [monthlyDays, setMonthlyDays] = useState('30');
  const [wattage, setWattage] = useState('100');
  const [kwhPrice, setKwhPrice] = useState('0,80');
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const hours = parseFloat(parseBrazilianNumber(dailyHours)) || 0;
    const days = parseFloat(parseBrazilianNumber(monthlyDays)) || 0;
    const watts = parseFloat(parseBrazilianNumber(wattage)) || 0;
    const price = parseFloat(parseBrazilianNumber(kwhPrice)) || 0;

    if (hours <= 0 || days <= 0 || watts <= 0) return;

    const dailyKwh = (watts * hours) / 1000;
    const monthlyKwh = dailyKwh * days;
    const monthlyCost = monthlyKwh * price;

    setResult({ monthlyKwh, monthlyCost, dailyKwh });
    onResultChange([
      { label: 'Potência', value: `${watts}W` },
      { label: 'Consumo Mensal', value: `${monthlyKwh.toFixed(2)} kWh` },
      { label: 'Custo Mensal', value: `R$ ${monthlyCost.toFixed(2)}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <FormField label="Potência (Watts)" value={wattage} onChange={setWattage} required isNumeric type="text" />
          <FormField label="Horas por dia" value={dailyHours} onChange={setDailyHours} required isNumeric type="text" />
          <FormField label="Dias por mês" value={monthlyDays} onChange={setMonthlyDays} required isNumeric type="text" />
          <FormField label="Preço kWh (R$)" value={kwhPrice} onChange={setKwhPrice} required isNumeric type="text" />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover transition-all flex items-center gap-2">
            <Icon name="play" className="w-5 h-5" /> Calcular Consumo
          </button>
        </div>
        {result && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Consumo Diário" value={`${result.dailyKwh.toFixed(2)} kWh`} color="blue" />
            <ResultCard title="Consumo Mensal" value={`${result.monthlyKwh.toFixed(2)} kWh`} color="indigo" />
            <ResultCard title="Custo Mensal" value={`R$ ${result.monthlyCost.toFixed(2)}`} color="purple" />
          </div>
        )}
      </div>
    </div>
  );
};

export default EnergyCalculator;
